import React from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { IOrderProduct } from '../../types/orderProduct';
import { IOrder, IUser } from '../../types';
import { OrderSummary } from '../OrderSummary';
import { ShopMode } from '../../redux/types';

const useStyles = makeStyles((theme) => ({
  listItem: {
    padding: theme.spacing(1, 0),
  },
  total: {
    fontWeight: 700,
  },
  title: {
    marginTop: theme.spacing(2),
  },
}));

interface ReviewProps {
  user: IUser;
  items: IOrderProduct[];
  order: Partial<IOrder>;
}
const Review: React.FC<ReviewProps> = ({ user, items, order }) => {
  const classes = useStyles();

  const deliveryDate = !!order.deliveryDate ? moment(order.deliveryDate).format('dddd D MMMM YYYY') : 'Non disponibile';

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Riepilogo ordine
      </Typography>
      <OrderSummary
        orderProducts={items}
        isUserLogged={!!user}
        partner={user.partner}
        shopMode={ShopMode.LocalDelivery}
      />
      <Grid>
        <Typography variant="h6" gutterBottom className={classes.title}>
          Indirizzo di consegna
        </Typography>
        <Typography gutterBottom>{`${order.name} ${order.surname}`}</Typography>
        <Typography gutterBottom>{`${order.address} ${order.city}`}</Typography>
        <Typography gutterBottom>{order.note}</Typography>
      </Grid>
      <Grid>
        <Typography variant="h6" gutterBottom className={classes.title}>
          Data di consegna
        </Typography>
        <Typography gutterBottom>{deliveryDate}</Typography>
      </Grid>
    </>
  );
};

export default Review;
